<template>
  <div v-if="enabled">
    <h3 v-if="title" class="text-lg font-heading font-semibold text-mifo-primary mb-4">{{ title }}</h3>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Institution</label>
        <input v-model="modelValue.institution" type="text" class="input-field" placeholder="Institution" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Abteilung</label>
        <input v-model="modelValue.department" type="text" class="input-field" placeholder="Abteilung" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Anrede</label>
        <select v-model="modelValue.anrede" class="input-field">
          <option value="">Bitte wählen</option>
          <option v-for="option in anredeOptions" :key="option.value" :value="option.label">{{ option.label }}</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Titel</label>
        <input v-model="modelValue.titel" type="text" class="input-field" placeholder="z.B. Dr." />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Vorname</label>
        <input v-model="modelValue.firstName" type="text" class="input-field" placeholder="Vorname" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nachname</label>
        <input v-model="modelValue.lastName" type="text" class="input-field" placeholder="Nachname" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Straße</label>
        <input v-model="modelValue.street" type="text" class="input-field" placeholder="Straße" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Hausnummer</label>
        <input v-model="modelValue.houseNumber" type="text" class="input-field" placeholder="Hausnummer" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">PLZ</label>
        <input v-model="modelValue.postalCode" type="text" class="input-field" placeholder="PLZ" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Stadt</label>
        <input v-model="modelValue.city" type="text" class="input-field" placeholder="Stadt" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Land</label>
        <select v-model="modelValue.country" class="input-field">
          <option value="">Bitte wählen</option>
          <option v-for="country in countries" :key="country.code" :value="country.code" :disabled="country.code === ''">{{ country.name }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { FORM_FIELDS, COUNTRIES } from 'shared/constants'

export default {
  name: 'BillingAddressForm',
  props: {
    modelValue: { type: Object, required: true },
    enabled: { type: Boolean, default: false },
    title: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  setup() {
    const anredeOptions = FORM_FIELDS.ANREDE_OPTIONS
    const countries = COUNTRIES
    return { anredeOptions, countries }
  }
}
</script>

